function hash32(input) {
  const s = String(input || '')
  let h = 2166136261
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i)
    h = Math.imul(h, 16777619)
  }
  return h >>> 0
}

function pickColor(seed) {
  const palette = ['#FF5C5C', '#40E0D0', '#FFD233', '#5C6BC0', '#81C784', '#FF9800', '#BA68C8', '#4FC3F7']
  const h = hash32(seed)
  return palette[h % palette.length]
}

export function cuteAvatarDataUrl(seed, { size = 64 } = {}) {
  const color = pickColor(seed)
  const bg = '#FFFDF5'
  const stroke = '#2D3436'
  const s = Math.max(24, Number(size) || 64)
  const eyeY = Math.round(s * 0.42)
  const eyeX1 = Math.round(s * 0.38)
  const eyeX2 = Math.round(s * 0.62)
  const eyeR = Math.max(2, Math.round(s * 0.06))
  const smileY = Math.round(s * 0.62)
  const smileW = Math.round(s * 0.28)
  const smileH = Math.round(s * 0.16)
  const smileX = Math.round(s / 2 - smileW / 2)

  const svg = [
    `<svg xmlns="http://www.w3.org/2000/svg" width="${s}" height="${s}" viewBox="0 0 ${s} ${s}">`,
    `<rect x="0" y="0" width="${s}" height="${s}" rx="${Math.round(s * 0.28)}" fill="${bg}"/>`,
    `<rect x="${Math.round(s * 0.12)}" y="${Math.round(s * 0.12)}" width="${Math.round(s * 0.76)}" height="${Math.round(s * 0.76)}" rx="${Math.round(s * 0.24)}" fill="${color}" opacity="0.22"/>`,
    `<circle cx="${eyeX1}" cy="${eyeY}" r="${eyeR}" fill="${stroke}"/>`,
    `<circle cx="${eyeX2}" cy="${eyeY}" r="${eyeR}" fill="${stroke}"/>`,
    `<path d="M ${smileX} ${smileY} C ${smileX + Math.round(smileW * 0.25)} ${smileY + smileH} ${smileX + Math.round(smileW * 0.75)} ${smileY + smileH} ${smileX + smileW} ${smileY}" fill="none" stroke="${stroke}" stroke-width="${Math.max(2, Math.round(s * 0.06))}" stroke-linecap="round"/>`,
    `<rect x="2" y="2" width="${s - 4}" height="${s - 4}" rx="${Math.round(s * 0.28)}" fill="none" stroke="${stroke}" stroke-width="${Math.max(2, Math.round(s * 0.06))}" />`,
    `</svg>`,
  ].join('')

  return `data:image/svg+xml,${encodeURIComponent(svg)}`
}

export function avatarUrlForUser({ email, picture, id } = {}) {
  const pic = String(picture || '').trim()
  if (pic) return pic
  const seed = String(email || id || 'user').trim() || 'user'
  return cuteAvatarDataUrl(seed, { size: 72 })
}

